import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { Shift } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import PlannedBreaks from '../PlannedBreaks'
import TooltipIcon from '../TooltipIcon'

export interface Props {
  shift: Shift
  plannedBreaks: PlannedBreak[]
  fromCustom?: boolean
}

const ExtraInformation = ({ shift, plannedBreaks, fromCustom }: Props) => {
  const isOvertime = shift.isOvertime
  const hasLocation = !!shift.location
  const hasWorkArea = !!shift.workArea
  const hasNotes = !!shift.notes

  return (
    <Box gap="s16">
      {isOvertime && !fromCustom && (
        <Box gap="s16" flexDirection="row" alignItems="center">
          <TooltipIcon.Medium
            icon="clock"
            label={i18n.t('shift_management.actions_sidepanel.tooltip.time_period')}
            color="grey700"
          />
          <Box
            width="full"
            flexDirection="row"
            padding="s16"
            borderRadius={{ all: 'abs016' }}
            background="grey100"
          >
            <Tag type="purple">{i18n.t('shift_management.overtime_tag')}</Tag>
          </Box>
        </Box>
      )}
      {!!plannedBreaks.length && (
        <PlannedBreaks
          plannedBreaks={plannedBreaks}
          shift={shift}
          showDeleted
          canManage
          newVersion
        />
      )}
      {hasLocation && (
        <Box gap="s16" flexDirection="row" alignItems="center">
          <TooltipIcon.Medium
            icon="pin"
            label={i18n.t('shift_management.actions_sidepanel.tooltip.workplace')}
            color="grey700"
          />

          <Box width="full" padding="s16" borderRadius={{ all: 'abs016' }} background="grey100">
            <Text.Normal color="grey1000" ellipsis>
              {shift.location.attributes.name}
            </Text.Normal>
          </Box>
        </Box>
      )}
      {hasWorkArea && (
        <Box gap="s16" flexDirection="row" alignItems="center">
          <TooltipIcon.Medium
            icon="space-control"
            label={i18n.t('shift_management.actions_sidepanel.tooltip.work_area')}
            color="grey700"
          />

          <Box width="full" padding="s16" borderRadius={{ all: 'abs016' }} background="grey100">
            <Text.Normal color="grey1000" ellipsis>
              {shift.workArea.attributes.name}
            </Text.Normal>
          </Box>
        </Box>
      )}
      {hasNotes && (
        <Box gap="s16" flexDirection="row" alignItems="center">
          <TooltipIcon.Medium
            icon="comment"
            label={i18n.t('shift_management.actions_sidepanel.tooltip.notes')}
            color="grey700"
          />

          <Box width="full" padding="s16" borderRadius={{ all: 'abs016' }} background="grey100">
            <Text.Normal color="grey1000" ellipsis>
              {shift.notes}
            </Text.Normal>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default observer(ExtraInformation)
